import { find, get, groupBy, uniq, map, forEach, isEmpty, orderBy, } from "lodash";
/**
 * 将{@link http://192.168.100.162/next/developers/providers/cmdb/instance-graph-api-traverse-graph | 图遍历查询接口}返回的图数据转换为树结构数据。
 *
 * @category Others
 *
 * @public
 *
 * @example
 *
 * ```ts
 * const data: GraphData = {
 *   topic_vertices: [
 *     {
 *       instanceId: "1",
 *       name: "A",
 *     },
 *     {
 *       instanceId: "2",
 *       name: "B",
 *     }
 *   ],
 *   vertices: [
 *     {
 *       instanceId: "3",
 *       name: "C",
 *     },
 *     {
 *       instanceId: "4",
 *       name: "D",
 *     }
 *   ],
 *   edges: [
 *     {
 *       out: "1",
 *       in: "3",
 *       out_name: "children",
 *     },
 *     {
 *       out: "2",
 *       in: "4",
 *       out_name: "children",
 *     }
 *   ]
 * }
 * graphTree(data)
 * // Returns:
 * // [
 * //   {instanceId: "1", name: "A", children: [{instanceId: "3", name: "C"}]},
 * //   {instanceId: "2", name: "B", children: [{instanceId: "4", name: "D"}]}
 * // ]
 * ```
 *
 * @param value - 图数据。
 * @param query - 图查询条件及排序等。
 *
 * @returns 树结构数据。
 */
export function graphTree(value, query) {
    var _a, _b;
    if (!value) {
        return [];
    }
    var sort = query === null || query === void 0 ? void 0 : query.sort;
    var groupByEdgeOut = groupBy(value.edges, "out");
    var findChildren = function (node) {
        var relationEdges = groupByEdgeOut[node.instanceId];
        forEach(relationEdges, function (edge) {
            var key = edge.out_name;
            var foundInstance = find(value.vertices, ["instanceId", edge.in]);
            if (foundInstance) {
                var resultInstance = findChildren(foundInstance);
                if (node[key]) {
                    node[key].push(resultInstance);
                }
                else {
                    node[key] = [resultInstance];
                }
            }
        });
        if (sort) {
            var keyList = uniq(map(relationEdges, "out_name"));
            forEach(keyList, function (key) {
                if (!isEmpty(node[key])) {
                    node[key] = orderBy(node[key], function (item) { var _a; return (_a = get(item, sort.key)) !== null && _a !== void 0 ? _a : -Infinity; }, sort.order === -1 ? "desc" : "asc");
                }
            });
        }
        return node;
    };
    var result = (_b = (_a = value.topic_vertices) === null || _a === void 0 ? void 0 : _a.map(function (root) {
        return findChildren(root);
    })) !== null && _b !== void 0 ? _b : [];
    return result;
}
//# sourceMappingURL=graphTree.js.map